/**
 * Ring size picker
 *
 * Makes the ring size line item property mandatory: Add to cart and the dynamic
 * checkout buttons are blocked until a size is chosen. Also remembers the chosen
 * size per product for the session, so a variant change that re-renders the page
 * does not silently drop it.
 */
(function () {
  if (window.ringSizeValidator) return;
  window.ringSizeValidator = true;

  const SELECT_SELECTOR = 'select[data-ring-size-select]';
  const STORAGE_PREFIX = 'ring-size:';

  function wrapperOf(select) {
    return select.closest('[data-ring-size-wrapper]');
  }

  /** Selects belonging to a form, whether nested inside it or linked via `form=`. */
  function selectsForForm(form) {
    const all = Array.from(document.querySelectorAll(SELECT_SELECTOR));
    return all.filter((select) => select.form === form);
  }

  function showError(select) {
    const wrapper = wrapperOf(select);
    if (!wrapper) return;
    wrapper.classList.add('ring-size--invalid');
    const error = wrapper.querySelector('.ring-size__error');
    if (error) error.hidden = false;
  }

  function clearError(select) {
    const wrapper = wrapperOf(select);
    if (!wrapper) return;
    wrapper.classList.remove('ring-size--invalid');
    const error = wrapper.querySelector('.ring-size__error');
    if (error) error.hidden = true;
  }

  /** Returns the first empty ring size select of the form, or null when valid. */
  function firstMissing(form) {
    if (!form) return null;
    return selectsForForm(form).find((select) => !select.value) || null;
  }

  function reject(missing) {
    showError(missing);
    missing.scrollIntoView({ behavior: 'smooth', block: 'center' });
    try {
      missing.focus({ preventScroll: true });
    } catch (e) {
      missing.focus();
    }
  }

  // Capture phase on document so this runs before <product-form>'s own submit
  // handler, which is bound directly on the form.
  document.addEventListener(
    'submit',
    function (event) {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;

      const missing = firstMissing(form);
      if (!missing) return;

      event.preventDefault();
      event.stopPropagation();
      reject(missing);
    },
    true
  );

  // Dynamic checkout (Shop Pay, PayPal, ...) submits the same form without a
  // submit event we can rely on, so block the click itself.
  document.addEventListener(
    'click',
    function (event) {
      const button = event.target.closest(
        '.shopify-payment-button__button, .shopify-payment-button__more-options, [type="submit"]'
      );
      if (!button) return;

      const form = button.form || button.closest('form');
      const missing = firstMissing(form);
      if (!missing) return;

      event.preventDefault();
      event.stopPropagation();
      reject(missing);
    },
    true
  );

  document.addEventListener('change', function (event) {
    const select = event.target.closest ? event.target.closest(SELECT_SELECTOR) : null;
    if (!select) return;

    if (select.value) clearError(select);

    const wrapper = wrapperOf(select);
    const productId = wrapper && wrapper.dataset.productId;
    if (!productId) return;
    try {
      if (select.value) {
        sessionStorage.setItem(STORAGE_PREFIX + productId, select.value);
      } else {
        sessionStorage.removeItem(STORAGE_PREFIX + productId);
      }
    } catch (e) {
      /* private mode - selection just is not remembered */
    }
  });

  function restore() {
    document.querySelectorAll(SELECT_SELECTOR).forEach(function (select) {
      if (select.value) return;
      const wrapper = wrapperOf(select);
      const productId = wrapper && wrapper.dataset.productId;
      if (!productId) return;

      let saved = null;
      try {
        saved = sessionStorage.getItem(STORAGE_PREFIX + productId);
      } catch (e) {
        return;
      }
      if (!saved) return;

      const match = Array.from(select.options).find((option) => option.value === saved);
      if (match) select.value = saved;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restore);
  } else {
    restore();
  }
})();
